class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateVariantStatuses();
    this.updateMasterId();
    this.toggleAddButton();

    if (!this.currentVariant) {
      this.toggleAddButton();
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    //Update id for product form buttons
    document.querySelectorAll(".update-variant-id").forEach((button) => {
      button.setAttribute("data-variantid", this.currentVariant.id);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    this.getVariantData();
    const selectedVariants = this.variantData.filter(
      (variant) =>
        this.querySelector(":checked").value === variant.option1 ||
        this.querySelector(":checked").value === variant.option2 ||
        this.querySelector(":checked").value === variant.option3
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedVariants
        .filter(
          (variant) => variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
      this.setInputVisibility(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const url = `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${sectionId}`);
        const source = html.getElementById(`price-${sectionId}`);
        const skuSource = html.getElementById(`Sku-${sectionId}`);
        const skuDestination = document.getElementById(`Sku-${sectionId}`);
        const inventorySource = html.getElementById(`Inventory-${sectionId}`);
        const inventoryDestination = document.getElementById(
          `Inventory-${sectionId}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${sectionId}`);
        if (price) price.classList.remove("visibility-hidden");
        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        this.toggleAddButton();

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton() {
    let atcButtons = document.getElementById("add-to-cart-btns");
    let soldOutBtn = document.getElementById("product-sold-out");
    this.currentVariant.available
      ? atcButtons.classList.remove("hidden")
      : atcButtons.classList.add("hidden");
    this.currentVariant.available
      ? soldOutBtn.classList.add("hidden")
      : soldOutBtn.classList.remove("hidden");
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.updateOptions();
    this.updateFieldsetVisibility();
    this.updateCartButtonsInput();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const value = input.getAttribute("value");
      if (listOfAvailableOptions.includes(value)) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  setInputVisibility(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const value = input.getAttribute("value");
      const nearestDiv = input.closest("div");
      if (listOfAvailableOptions.includes(value)) {
        nearestDiv.classList.remove("hidden");
      } else {
        nearestDiv.classList.add("hidden");
      }
      // Bidirectional: Also update the availability of the input
      if (input.disabled !== listOfAvailableOptions.includes(value)) {
        input.disabled = !listOfAvailableOptions.includes(value);
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      const checkedInput = fieldset.querySelector("input:checked");
      return checkedInput ? checkedInput.value : null;
    });
  }

  updateFieldsetVisibility() {
    const fieldsets = this.querySelectorAll("fieldset.product-form__input");
    const fieldsetsArray = Array.from(fieldsets);
    const fieldset1 = fieldsetsArray[0];
    const inputs1 = fieldset1.querySelectorAll("input");

    if (fieldsetsArray.length === 2) {
      const fieldset2 = fieldsetsArray[1];
      const inputs2 = fieldset2.querySelectorAll("input");

      fieldset2.classList.add("hidden");

      // Add event listener to input elements in fieldset1
      inputs1.forEach((input) => {
        input.addEventListener("change", function () {
          // Toggle visibility of fieldset2 based on whether it contains the class "hidden"
          if (fieldset2.classList.contains("hidden")) {
            fieldset2.classList.remove("hidden");
          }

          if (!fieldset2.classList.contains("hidden")) {
            inputs2.forEach((radio) => (radio.checked = false));
          }
        });
      });
    }

    if (fieldsetsArray.length === 3) {
      const fieldset2 = fieldsetsArray[1];
      const fieldset3 = fieldsetsArray[2];
      const inputs2 = fieldset2.querySelectorAll("input");
      const inputs3 = fieldset3.querySelectorAll("input");

      fieldset2.classList.add("hidden");
      fieldset3.classList.add("hidden");

      // Add event listener to input elements in fieldset1
      inputs1.forEach((input) => {
        input.addEventListener("change", function () {
          // Toggle visibility of fieldset2 based on whether it contains the class "hidden"
          if (fieldset2.classList.contains("hidden")) {
            fieldset2.classList.remove("hidden");
          }

          if (
            !fieldset2.classList.contains("hidden") &&
            !fieldset3.classList.contains("hidden")
          ) {
            fieldset3.classList.add("hidden");
            inputs2.forEach((radio) => (radio.checked = false));
            inputs3.forEach((radio) => (radio.checked = false));
          }
        });
      });

      // Add event listener to input elements in fieldset2
      if (fieldset2) {
        // Check if fieldset2 is defined
        const inputs2 = fieldset2.querySelectorAll("input");
        inputs2.forEach((input) => {
          input.addEventListener("change", function () {
            // Toggle visibility of fieldset3 based on whether it contains the class "hidden"
            if (fieldset3.classList.contains("hidden")) {
              fieldset3.classList.remove("hidden");
              inputs3.forEach((radio) => (radio.checked = false));
            }
            if (
              !fieldset2.classList.contains("hidden") &&
              !fieldset3.classList.contains("hidden")
            ) {
              inputs3.forEach((radio) => (radio.checked = false));
            }
          });
        });
      }
    }
  }

  updateCartButtonsInput() {
    const AddToCartBtns = document.querySelectorAll(".add-to-cart-btns");
    const fieldsets = document.querySelectorAll("fieldset.product-form__input");
    const inputs = document.querySelectorAll("fieldset.product-form__input input");
    const fieldsetsArray = Array.from(fieldsets);
    const selectVariantMessage = document.querySelector("div.select-variant-message");

    AddToCartBtns.forEach(button => button.classList.add("cursor-not-allowed", "pointer-events-not-allowed", "disabled"));
    selectVariantMessage.classList.remove("hidden");

    inputs.forEach((input) => {
      input.addEventListener("change", function () {
        const checked = document.querySelectorAll("fieldset.product-form__input input:checked");
        if (fieldsetsArray.length === 1) {
          if (Array.from(checked).length <= 0) {
            AddToCartBtns.forEach(button => button.classList.add("cursor-not-allowed", "pointer-events-not-allowed", "disabled"));
            selectVariantMessage.classList.remove("hidden");
          }
          else {
            AddToCartBtns.forEach(button => button.classList.remove("cursor-not-allowed", "pointer-events-not-allowed", "disabled"));
            selectVariantMessage.classList.add("hidden");
          }
        };
        if (fieldsetsArray.length === 2) {
          if (Array.from(checked).length <= 1) {
            AddToCartBtns.forEach(button => button.classList.add("cursor-not-allowed", "pointer-events-not-allowed", "disabled"));
            selectVariantMessage.classList.remove("hidden");
          }
          else {
            AddToCartBtns.forEach(button => button.classList.remove("cursor-not-allowed", "pointer-events-not-allowed", "disabled"));
            selectVariantMessage.classList.add("hidden");
          }
        };
        if (fieldsetsArray.length === 3) {
          if (Array.from(checked).length <= 2) {
            AddToCartBtns.forEach(button => button.classList.add("cursor-not-allowed", "pointer-events-not-allowed", "disabled"));
            selectVariantMessage.classList.remove("hidden");
          }
          else {
            AddToCartBtns.forEach(button => button.classList.remove("cursor-not-allowed", "pointer-events-not-allowed", "disabled"));
            selectVariantMessage.classList.add("hidden");
          }
        };
      });
    });
  }
}

customElements.define("variant-radios", VariantRadios);
